import React from 'react';

export default function SkillBadge({ icon, label }) {
  return (
<div className="flex flex-col items-center gap-2 p-3 bg-white/5 rounded-xl transition-all border border-white/10 backdrop-blur-sm shadow-inner min-w-[100px] hover:scale-[1.02]">

      {icon ? (
        <img
          src={icon}
          alt={label}
          className="h-6 w-6 object-contain grayscale-[30%]"
        />
      ) : (
        <div className="h-6 w-6 text-sm text-slate-500 font-mono">?</div>
      )}
      <span className="text-xs text-slate-300 font-medium font-inter">
        {label}
      </span>
    </div>
  );
}
